import { createMuiTheme } from "@material-ui/core";
import palette from "./palette";

export default createMuiTheme({
  palette: {
    primary: {
      main: palette.slate,
    },
    secondary: {
      main: palette.sunburst,
    },
  },
  overrides: {
    // fix empty text field label position
    MuiFormControl: {
      root: {
        " & label[data-shrink='false']": {
          top: "-10px",
          color: palette.typography.black.solid,
          transform: `translate(10px, 20px) scale(1)`,
        },
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: "0.875rem",
        "&$focused": {
          color: palette.blue,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          borderColor: palette.blue,
        },
      },
      input: {
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        letterSpacing: "0.0025rem",
        padding: "0.3125rem 0.625rem",
        height: "1.25rem",
        "&::-webkit-input-placeholder": {
          color: palette.typography.black.solid,
          opacity: `1 !important`,
        },
      },
      notchedOutline: {
        fontSize: "0.875rem",
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: "0.625rem",
        textAlign: "right",
      },
      contained: {
        marginRight: 0,
        marginTop: 0,
      },
    },
    MuiCheckbox: {
      root: {
        padding: 3,
        "& svg": {
          fontSize: "1rem",
        },
      },
    },
    MuiFormControlLabel: {
      root: {
        fontSize: "0.75rem",
        lineHeight: "1rem",
        marginRight: 0,
      },
    },
    MuiButton: {
      root: {
        height: "2rem",
      },
      label: {
        fontSize: "0.875rem",
        lineHeight: "1rem",
        fontWeight: "normal",
        textTransform: "capitalize",
      },
    },
    MuiSvgIcon: {
      colorSecondary: {
        color: palette.typography.white.inactive,
      },
    },
    MuiTextField: {
      root: {
        marginTop: 0,
      },
    },
    MuiSnackbar: {
      anchorOriginTopCenter: {
        top: "50% !important",
      },
    },
    MuiPickersDay: {
      daySelected: {
        border: 0,
      },
      current: {
        border: "0.063rem solid #DC0032",
      },
    },
    MuiAutocomplete: {
      popupIndicator: {
        transition: "transform linear 200ms",
      },
      popupIndicatorOpen: {
        color: palette.blue,
        transform: "rotate(180deg)",
      },
    },
  },
});
